angular.module('public.security-manager.employee').component('gccsEmployeeClientApproveClientPreview', {
  template: require('./template.pug'),
  controller: 'EmployeeClientApproveClientPreviewController',
  bindings: {
    client: '<',
    employee: '<',
    isSelected: '<'
  }
});
